import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { RequestFormService } from '../../service/requestForm/request-form.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss'],
})
export class CustomInputComponent implements OnInit, OnDestroy {
  @Input() type: string = 'text';
  @Input() label!: string;
  @Input() inputId!: string;
  @Input() inputName!: string;
  @Input() form!: FormGroup;
  @Input() controlname!: FormControl | any;
  @Input() formSubmitted!: boolean;
  @Input() errorMessage!: string;
  @Input() readonly?: boolean | any = false;
  @Input() required?: boolean | any = false;
  @Input() placeholder!: string;
  @Output() onInput = new EventEmitter<Event>();

  private sub?: Subscription;

  constructor(
    private requestFormService: RequestFormService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.controlname && this.controlname.valueChanges) {
      this.sub = this.controlname.valueChanges.subscribe(() => {
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get formControl() {
    return this.form?.get(this.controlname);
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
